import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import logo from "assets/imgs/looptv-logo.png";
import { useHistory } from "react-router-dom";

export default function Sidebar() {
  const router = useHistory();
  const [collapseState, setCollapseState] = useState("");
  const handleCollapse = (state) => {
    if (state === collapseState) setCollapseState("");
    else setCollapseState(state);
  };

  const handleRedirect = (to) => {
    setCollapseState("");
    router.push(to);
  };
  return (
    <Paper
      elevation={3}
      style={{
        padding: "15px",
        height: "100vh",
        position: "fixed",
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingBottom: "15px",
          paddingTop: "15px",
        }}
      >
        <img src={logo} alt="Loop TV" style={{ maxWidth: "150px" }} />
        <Typography variant="h6">Igual nenhuma outra!</Typography>
        <Divider style={{ margin: "10px" }} />
      </div>
      <div style={{ textAlign: "center" }}>
        <Typography variant="h5">Menu</Typography>
        <List subheader={<li />}>
          <ListItem button onClick={() => handleRedirect("/painel/")}>
            <ListItemText inset primary="Home" />
          </ListItem>
          <ListItem button>
            <ListItemText
              inset
              primary="Quadros"
              onClick={() => handleCollapse("Quadros")}
            />
          </ListItem>
          <Collapse in={collapseState === "Quadros"}>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/criar-quadro")}
            >
              <ListItemText inset secondary="Criar Quadro" />
            </ListItem>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/ver-quadros")}
            >
              <ListItemText inset secondary="Ver Quadros" />
            </ListItem>
          </Collapse>

          <ListItem button onClick={() => handleCollapse("Anunciantes")}>
            <ListItemText inset primary="Anunciantes" />
          </ListItem>

          <Collapse in={collapseState === "Anunciantes"}>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/criar-anunciante")}
            >
              <ListItemText inset secondary="Criar Anunciante" />
            </ListItem>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/ver-anunciantes")}
            >
              <ListItemText inset secondary="Ver Anunciantes" />
            </ListItem>
          </Collapse>

          <ListItem button onClick={() => handleCollapse("Categorias")}>
            <ListItemText inset primary="Categorias" />
          </ListItem>

          <Collapse in={collapseState === "Categorias"}>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/criar-categoria")}
            >
              <ListItemText inset secondary="Criar Categoria" />
            </ListItem>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/ver-categorias")}
            >
              <ListItemText inset secondary="Ver Categorias" />
            </ListItem>
          </Collapse>

          <ListItem button onClick={() => handleCollapse("Tags")}>
            <ListItemText inset primary="Tags" />
          </ListItem>

          <Collapse
            in={collapseState === "Tags"}
            onClick={() => handleRedirect("/painel/criar-tag")}
          >
            <ListItem button>
              <ListItemText inset secondary="Criar Tag" />
            </ListItem>
            <ListItem button onClick={() => handleRedirect("/painel/ver-tags")}>
              <ListItemText inset secondary="Ver Tags" />
            </ListItem>
          </Collapse>
          <ListItem button onClick={() => handleCollapse("Produtos")}>
            <ListItemText inset primary="Produtos" />
          </ListItem>
          <Collapse in={collapseState === "Produtos"}>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/criar-produto")}
            >
              <ListItemText inset secondary="Criar Produto" />
            </ListItem>
            <ListItem
              button
              onClick={() => handleRedirect("/painel/ver-produtos")}
            >
              <ListItemText inset secondary="Ver Produtos" />
            </ListItem>
          </Collapse>
        </List>
      </div>
    </Paper>
  );
}
